import { SVGProps } from "react";

export const ZoomSVG = ({
  color = "#414959",
  ...others
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...others}
  >
    <g filter="url(#filter0_b_2376_77194)">
      <rect width="24" height="24" rx="12" fill="white" fillOpacity="0.25" />
      <path
        d="M6.66667 10C6.47778 10 6.31956 9.936 6.192 9.808C6.064 9.68044 6 9.52222 6 9.33333V6.66667C6 6.47778 6.064 6.31933 6.192 6.19133C6.31956 6.06378 6.47778 6 6.66667 6H9.33333C9.52222 6 9.68067 6.06378 9.80867 6.19133C9.93622 6.31933 10 6.47778 10 6.66667C10 6.85556 9.93622 7.01378 9.80867 7.14133C9.68067 7.26933 9.52222 7.33333 9.33333 7.33333H8.26667L9.88333 8.95C10.0056 9.07222 10.0667 9.22222 10.0667 9.4C10.0667 9.57778 10 9.73333 9.86667 9.86667C9.74444 9.98889 9.58889 10.05 9.4 10.05C9.21111 10.05 9.05556 9.98889 8.93333 9.86667L7.33333 8.26667V9.33333C7.33333 9.52222 7.26956 9.68044 7.142 9.808C7.014 9.936 6.85556 10 6.66667 10ZM14.1333 9.86667C14.0111 9.74444 13.95 9.58889 13.95 9.4C13.95 9.21111 14.0111 9.05556 14.1333 8.93333L15.7333 7.33333H14.6667C14.4778 7.33333 14.3196 7.26933 14.192 7.14133C14.064 7.01378 14 6.85556 14 6.66667C14 6.47778 14.064 6.31933 14.192 6.19133C14.3196 6.06378 14.4778 6 14.6667 6H17.3333C17.5222 6 17.6804 6.06378 17.808 6.19133C17.936 6.31933 18 6.47778 18 6.66667V9.33333C18 9.52222 17.936 9.68044 17.808 9.808C17.6804 9.936 17.5222 10 17.3333 10C17.1444 10 16.9862 9.936 16.8587 9.808C16.7307 9.68044 16.6667 9.52222 16.6667 9.33333V8.26667L15.05 9.88333C14.9278 10.0056 14.7778 10.0667 14.6 10.0667C14.4222 10.0667 14.2667 10 14.1333 9.86667ZM14.6667 18C14.4778 18 14.3196 17.936 14.192 17.808C14.064 17.6804 14 17.5222 14 17.3333C14 17.1444 14.064 16.9862 14.192 16.8587C14.3196 16.7307 14.4778 16.6667 14.6667 16.6667H15.7333L14.1167 15.05C13.9944 14.9278 13.9333 14.7778 13.9333 14.6C13.9333 14.4222 14 14.2667 14.1333 14.1333C14.2556 14.0111 14.4111 13.95 14.6 13.95C14.7889 13.95 14.9444 14.0111 15.0667 14.1333L16.6667 15.7333V14.6667C16.6667 14.4778 16.7307 14.3193 16.8587 14.1913C16.9862 14.0638 17.1444 14 17.3333 14C17.5222 14 17.6804 14.0638 17.808 14.1913C17.936 14.3193 18 14.4778 18 14.6667V17.3333C18 17.5222 17.936 17.6804 17.808 17.808C17.6804 17.936 17.5222 18 17.3333 18H14.6667ZM6.66667 18C6.47778 18 6.31956 17.936 6.192 17.808C6.064 17.6804 6 17.5222 6 17.3333V14.6667C6 14.4778 6.064 14.3193 6.192 14.1913C6.31956 14.0638 6.47778 14 6.66667 14C6.85556 14 7.014 14.0638 7.142 14.1913C7.26956 14.3193 7.33333 14.4778 7.33333 14.6667V15.7333L8.95 14.1167C9.07222 13.9944 9.22222 13.9333 9.4 13.9333C9.57778 13.9333 9.73333 14 9.86667 14.1333C9.98889 14.2556 10.05 14.4111 10.05 14.6C10.05 14.7889 9.98889 14.9444 9.86667 15.0667L8.26667 16.6667H9.33333C9.52222 16.6667 9.68067 16.7307 9.80867 16.8587C9.93622 16.9862 10 17.1444 10 17.3333C10 17.5222 9.93622 17.6804 9.80867 17.808C9.68067 17.936 9.52222 18 9.33333 18H6.66667Z"
        fill={color}
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#D6DDEB" />
    </g>
    <defs>
      <filter
        id="filter0_b_2376_77194"
        x="-1"
        y="-1"
        width="26"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.5" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_2376_77194"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2376_77194"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
